import logger from './utils/logger';
// export const BACKEND_URL = 'https://api.beta.vortic.link/';
export const BACKEND_URL = process.env.API_URL;
export const API_ENV = process.env.API_ENV;

// console.log('API_URL = ', process.env.API_URL)
export const IS_PRODUCTION_API_ENV = API_ENV === 'production';
// logger.log('process.env.API_URL = ', process.env.API_URL);
// logger.log('BACKEND_URL = ', BACKEND_URL);
